import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { Hero } from '../components/Hero';

export function Contact() {
  return (
    <div>
      <Hero
        title="Contact Us"
        description="Have questions or need to schedule an appointment? We're here to help. Reach out to us through any of the methods below."
        image="https://images.unsplash.com/photo-1590228947498-5f58cc4be4d7?auto=format&fit=crop&q=80"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid lg:grid-cols-2 gap-12">
          <div>
            <div className="bg-white rounded-lg shadow-md p-8 mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h2>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <Phone className="h-6 w-6 text-blue-600 mt-1" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Phone</h3>
                    <p className="text-gray-600">
                      Main: <a href="tel:+14702393602" className="hover:text-blue-600">(470) 239-3602</a>
                    </p>
                    <p className="text-gray-600">Fax: (404) 698-3463</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <Mail className="h-6 w-6 text-blue-600 mt-1" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Email</h3>
                    <p className="text-gray-600">
                      <a href="mailto:clinic@juncosneuroconsulting.com" className="hover:text-blue-600">
                        clinic@juncosneuroconsulting.com
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <MapPin className="h-6 w-6 text-blue-600 mt-1" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Address</h3>
                    <p className="text-gray-600">
                      1100 Northside Forsyth Dr., Suite 210<br />
                      Cumming, GA 30041
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <Clock className="h-6 w-6 text-blue-600 mt-1" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Hours</h3>
                    <p className="text-gray-600">Monday–Thursday: 9:00 AM – 5:00 PM</p>
                    <p className="text-gray-600">Friday: 9:00 AM – 12:00 PM</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-blue-50 rounded-lg p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">Important Notice</h2>
              <p className="text-gray-600 mb-4">
                For medical emergencies, please call 911 or visit the nearest emergency room.
              </p>
              <p className="text-gray-600">
                For urgent matters during business hours, please call our office directly
                at <a href="tel:+14702393602" className="hover:text-blue-600">(470) 239-3602</a>.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3305.733248549831!2d-84.14462692412832!3d34.065893780599716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f59f798bbe0f95%3A0x8e252b8f85d2ea2f!2s1100%20Northside%20Forsyth%20Dr%2C%20Cumming%2C%20GA%2030041!5e0!3m2!1sen!2sus!4v1709438235044!5m2!1sen!2sus"
              width="100%"
              height="600"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        <div className="mt-12 bg-blue-50 rounded-lg p-8 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Patient Portal</h2>
          <p className="text-gray-600 mb-6">
            Access your health information, communicate with our team, and manage your appointments
            through our secure patient portal.
          </p>
          <a
            href="https://health.healow.com/juncosneuro"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-blue-600 text-white px-8 py-3 rounded-md font-semibold hover:bg-blue-700 transition-colors"
          >
            Access Patient Portal
          </a>
        </div>
      </div>
    </div>
  );
}